import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { CustomersFilter } from '../../../entities'
import { getAllCustomers } from '../../customers'

export default function useCustomers(query: PaginatedRequest<CustomersFilter>) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['customers', query],
    () => getAllCustomers(query),
    {
      keepPreviousData: true
    }
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
